export default {"src":"/_next/static/media/ignis.b0a994a4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};